export const lang = {
  home: {
    home:"Home",
    work:"Work",
    about:"About",
    teams:"Team",
    
    Summit: "BlockPower",
    theSummit: "BlockPower is a revolutionary energy project based on blockchain technology, dedicated to changing the production, distribution, and trading patterns of nuclear energy and other clean energy through innovative blockchain applications. Combining the decentralized, tamper-free, and transparent features of blockchain, the project aims to improve the efficiency of the energy industry, especially in information transmission, data transparency, and smart contract applications. BlockPower provides a safe, transparent, and traceable energy management and trading ecosystem for the global energy market, promoting the wide application of clean energy.",
    WhitePaper: "WhitePaper",

    core: "Project Vision",
    Enhancingtitle:"",
    Enhancing: "BlockPower's vision is to create a global decentralized, intelligent energy system driven by blockchain technology, making the energy production, distribution, and consumption processes completely transparent. Through innovative management models, BlockPower hopes to promote the adoption and application of clean energy, reduce carbon emissions, and contribute to the global Sustainable Development Goals while ensuring energy security and improving efficiency.",
    Promotingtitle:"",
    Promoting: "",
    
    Fosteringtitle:"User Preference",
    Fostering: "COGGIE is dedicated to providing the best trading experience for global users, ensuring that every user can efficiently and safely engage in cryptocurrency trading through a friendly and simple user interface, 24/7 global customer support, and flexible trading solutions.",
    Protectingtitle:"Globalization",
    Protecting: "As a global trading platform, COGGIE supports various languages and fiat trading pairs, catering to the localized needs of users from different regions while actively promoting the popularization and development of digital assets worldwide.",
    
    
    Features: "Data Security and Privacy Protection",
    Driventitle: "Data Encryption",
    Driven: 'All transactions and energy data will be encrypted and stored before being uploaded to the blockchain to prevent unauthorized access and data leakage. ',

    Realtitle: "Privacy Protection Agreement",
    Real: "The platform supports privacy protection agreements such as zero-knowledge proof. Users can participate in energy transactions while protecting their privacy to ensure the security of sensitive data. ",
   
    Personalizedtitle: "Access Control",
    Personalized: "The system uses role-based access control (RBAC) and hierarchical authority management to set different permissions for different roles, such as users, manufacturers, and nodes, to prevent data abuse. ",
    
    Onetitle:'Decentralized Storage',
    One:'Through decentralized storage technologies such as IPFS, the platform realizes the distributed storage of data to avoid the risk of single points of failure brought by centralized systems.',

    Twotitle:'Multi-Layer Protection Mechanism',
    Two:'The BlockPower platform deploys a multi-layer protection mechanism, including a firewall, intrusion detection system (IDS), distributed defense, and real-time monitoring, to ensure the security of data storage and transmission.',

    Threetitle:'Legal Compliance',
    Three:'The platform strictly complies with international data privacy regulations (such as GDPR) in data storage and processing, managing data under the authorization of users to ensure data transparency and compliance.',


    FINQbot: "Project Objectives",
    Introductiontile:'Establish a transparent energy management chain throughout the whole process:',
    Introduction: " Ensure traceability and data transparency in every link from energy production to consumption.",
    
    Introductiononetitle:'Build a peer-to-peer energy trading platform:',
    Introductionone: " Allow users to trade directly with clean energy producers, reducing reliance on traditional intermediaries and improving trading efficiency.",
    
    Introductiontwotitle:"Promote clean energy consumption:",
    Introductiontwo:" Encourage users to choose clean energy through token incentives, reduce environmental burdens, and promote the concept of green consumption.",

    Introductionthreetitle:"Improve the security of nuclear data management:",
    Introductionthree:" Utilize blockchain technology to ensure the security, encrypted storage, and compliance transparency of nuclear data, enhancing social trust.",

    Introductionfourtitle:'Promote ecosystem cooperation in the energy sector: ',
    Introductionfour:'Establish an open platform to attract participation from different energy suppliers, technology companies, and government agencies, jointly promoting the application and development of blockchain in the energy sector.',

    Introduction_two: "• Risk Assessment: Identified risks are evaluated to determine their impact on the platform, and mitigation strategies are developed.",
    Introductionshree: "• Risk Management: Risk management measures include setting up early warning systems and",
    Introductionfove: "• Risk Management: Risk management measures include setting up early warning systems and",

    
    Token: "Token",
    Name: "Token Name: PWR ",
    Total: "Total Supply: 1.2 billion",
    SubscriptionTime:"",
    SubscriptionPrice:"",
    SubscriptionQuantity:"",


    Foundation: "Energy Trading and Platform Operations: 40%",
    Technical: "Incentives and Rewards: 25%",
    Project: "Ecosystems and Strategic Partners: 15%",
    Circulation: "Operations Team: 10%",
    Airdrop: "Public Sales: 10%",
    Operations:"",


    team:'Our core team',


    Wealth:"The core team of BlockPower consists of a group of professionals with deep experience in blockchain technology, energy management, nuclear energy research, and clean energy. The team members have not only accumulated rich practical experience in their respective fields but also possess strong technological innovation abilities and a global vision. Our team focuses on promoting the integration of blockchain and nuclear energy, aiming to build an efficient, transparent, and sustainable energy ecosystem.",

    Pedro:'Pedro Hill: Founder and mentor',
    CTO:'Rafferty Finnegan: CTO',
    COO:'Thaddeus Hawthorne: COO',
    Augustine:'Augustine Callahan: Lead mentor',

    Cooperate:'Cooperate',
    partners:'our partners',

  },
  
};